<script setup>

const route = useRoute()
const { getFBLocationSearch, getFBViewLocations, getFBPricesDates, getFBSelectPackage, getCourseById, getFBSelectProgram, getFBGeolocationLookup } = useCourseData()
const data = route.params.courseData;
const error = route.params.courseError;
const {setPageHead} = useGlobalFeaturesData();

if (error) {
  throw createError({ statusCode: 404, statusMessage: "Page not found!" })
}
let preview = route.query.preview
if (!preview && data.value.publishedAt == null) {
  throw createError({ statusCode: 404, statusMessage: "Page not found!" })
}
// Set meta tags in head for SEO
if(data.value && data.value.seo) {
  setPageHead(data.value.seo, route.path);
}
// Show/hide Ribbon Form and Jump to top button
const showBrochureRibbon = data.value ? data.value.brochureRibbon : null;
const brochureRibbonTags = data.value ? data.value.brochureRibbonTags : []
const displayJumpToTop = data.value && data.value.jumpToTop ? data.value.jumpToTop : false;
const showChatService = data.value.showChatService;

// ZigZag resources
const config = useRuntimeConfig()
const { version } = useZigZag()
const { data: zigzag, refresh, error: zigzagError } = await version(config.public.zigzagUrl)

const time = zigzag.value ? zigzag.value.t : 0;
const sha = zigzag.value ? zigzag.value.sha : 'versionnotfound';

const determineFB = (course) => {
  if (course.floatingBlock !== null) {
    return course.floatingBlock.blockType;
  }
  return course.floatingBlockType;
}
// Get Floating block shared content
let floatingBlock = null;
const fb = determineFB(data.value);

switch (fb) {
  case 'floating-block-location-search':
    const {data: fbLocationSearch} = await getFBLocationSearch();
    floatingBlock = fbLocationSearch;
    break;
  case 'floating-block-view-locations':
    const {data: fbViewLocations} = await getFBViewLocations();
    floatingBlock = fbViewLocations;
    break;
  case 'floating-block-prices-dates':
    const {data: fbPricesDates} = await getFBPricesDates();
    floatingBlock = fbPricesDates;
    break;
  case 'floating-block-select-package':
    const {data: fbSelectPackage} = await getFBSelectPackage();
    floatingBlock = fbSelectPackage;      
    break;
  case 'floating-block-select-program':
    const {data: fbSelectProgram} = await getFBSelectProgram();
    floatingBlock = fbSelectProgram;      
    break;
  case 'floating-block-geolocation-lookup':
    const {data: fbGeolocationLookup} = await getFBGeolocationLookup();
    floatingBlock = fbGeolocationLookup;      
    break;
}
</script>

<template>
  <LayoutGridLayout :data="data" :floatingBlock="floatingBlock"/>
  <LayoutRibbonForm v-if="showBrochureRibbon" :ribbonTags="brochureRibbonTags"/>
  <LayoutBackToTop v-if="displayJumpToTop"/>
  <ChatService v-if="showChatService"/>
</template>